import React from "react";
import { useOverrides } from "@quarkly/components";
import { Text, Icon, LinkBox, Box } from "@quarkly/widgets";
import { IoIosChatboxes } from "react-icons/io";
const defaultProps = {
	"min-width": "100px",
	"min-height": "100px",
	"position": "fixed",
	"bottom": "0px",
	"z-index": "9",
	"left": "0px"
};
const overrides = {
	"linkBox": {
		"kind": "LinkBox",
		"props": {
			"display": "flex",
			"align-items": "flex-start",
			"flex-direction": "column",
			"justify-content": "center",
			"margin": "0px 20px 20px 20px",
			"target": "_blank",
			"href": "https://max.ru/join/nj0GAynGnsPFmszMTqU8ygM8RbCKAGdOJAQfMqBWjTc",
			"bottom": "0px",
			"left": "0px",
			"hover-opacity": "0.8",
			"transition": "--opacityOut"
		}
	},
	"text": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 10px 0px",
			"box-shadow": "0 0 16px 0 rgb(152 152 152 / 50%)",
			"background": "--primary",
			"padding": "8px 16px 8px 16px",
			"border-radius": "20px",
			"font": "--button",
			"color": "--white",
			"children": "Чат-сообщества"
		}
	},
	"icon": {
		"kind": "Icon",
		"props": {
			"category": "io",
			"icon": IoIosChatboxes,
			"size": "44px",
			"color": "--white",
			"background": "--color-darkL1",
			"padding": "5px 5px 5px 5px",
			"border-radius": "50%",
			"border-width": "3px",
			"border-style": "solid",
			"border-color": "--color-primary"
		}
	}
};

const Chat = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Box {...rest}>
		<LinkBox {...override("linkBox")}>
			<Text {...override("text")} />
			<Icon {...override("icon")} />
		</LinkBox>
		{children}
	</Box>;
};

Object.assign(Chat, { ...Box,
	defaultProps,
	overrides
});
export default Chat;